export default __webpack_public_path__ + "static/media/kaitlin.172c408c.png";